export default function (number) {
    let percent;

    if (number == null) {
        percent = "N/A";
    } else {
        percent = (number * 100).toFixed(1) + "%";
    }

    return percent;
}


// WEBPACK FOOTER //
// ./src/js/utilities/get-percent.js